import React from 'react'

const BookHubThemeContext = React.createContext({
  isDarkTheme: false,
  onClickThemeIcon: () => {},
})

export default BookHubThemeContext
